import { metricPanelDataAtomFamily } from '../atoms';
import { useAtomValue, useSetAtom } from 'jotai';

// react query hooks are not scaling well with increase of consumers
// in a scenario like compare, 10 metrics card with 5 compare filters would mean 50 direct hook consumers
// this makes UI sluggish as the mount/unmount cost of query hooks are high
// the atom family based approach uses data tag to create dynamic atom stores to propogate data between react query and consumers
// this ensures query hooks will not increase based on cards

// this solution adds atom as a dependency to hook usage for now
// because the current approach passes tags, it's simple but enforces a tight coupling
// an alternate approach is to use data store generators and pass hooks, that decouples atom dependency
// as user can pass any hook and we can default to a dummy hook
// but it increases the code required, as we have to pre define the stores
// TODO: I'll revisit and refactor the solution post the release as there are time constraints

interface dataFamily {
  tag: string;
  defaultValue: any;
}

export enum DATA_TAGS {
  primary = 'primary',
  primaryDod = 'primary-dod',
  metricFilter = 'metric-filter',
  secondary = 'secondary',
  secondaryDod = 'secondary-dod',
  secondaryMetricFilter = 'secondary-metric-filter',
  compare = 'compare',
  secondaryCompare = 'secondary-compare',
  liveSummary = 'live-summary',
  aiAlertEvents = 'ai-alert-events',
  manualAlertEvents = 'manual-alert-events',
}

export function useSetData({ tag, defaultValue = null }: dataFamily) {
  const dataAtom = metricPanelDataAtomFamily({ tag, defaultValue });
  const setData = useSetAtom(dataAtom);
  return setData;
}

export function useGetData({ tag, defaultValue = null }: dataFamily) {
  const dataAtom = metricPanelDataAtomFamily({ tag, defaultValue });
  const data = useAtomValue(dataAtom);
  return data;
}
